<div class="modal-header">
    <h4 class="modal-title">
        <ng-container *ngIf="data && isCloning">
            Cloning Global Company Prefix
        </ng-container>
        <ng-container *ngIf="data && !isCloning">
            Edit Global Company Prefix
        </ng-container>
        <ng-container *ngIf="!data">
            Create Global Company Prefix
        </ng-container>
    </h4>
    <button type="button" class="btn-close focus:outline-none focus:shadow-none" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <i class="fas fa-times fa-1x"></i>
    </button>
</div>
<div class="modal-body">
    <div class="flex flex-row justify-between">
        <div class="flex flex-column basis-2/6" style="flex-basis: 33.333333%;">
            <div class="py-2">
                <span>Global Company Prefix</span>
                <dx-text-box
                        [(value)]="globalCompanyPrefix"
                        [showClearButton]="true"
                        placeholder="Enter global company prefix"
                >
                    <dx-validator>
                        <dxi-validation-rule
                                type="required"
                                message="Global Company Prefix Required"
                        >
                        </dxi-validation-rule>
                        <dxi-validation-rule
                                type="pattern"
                                pattern="^[0-9]{6,10}$"
                                message="Please use only digits. Min 6 and max 10.">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            <div class="py-2">
                <span>Business Entity Name</span>
                <dx-text-box
                        [(value)]="businessEntityName"
                        [showClearButton]="true"
                        [disabled]="isCloning"
                        placeholder="Enter business entity name"
                >
                    <dx-validator>
                        <dxi-validation-rule
                                type="required"
                                message="Business Entity Name Required"
                        >
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
        </div>
        <div class="flex flex-column basis-2/6" style="flex-basis: 33.333333%;">
            <div class="py-2">
                <span>Website</span>
                <dx-text-box
                        [(value)]="website"
                        [showClearButton]="true"
                        [disabled]="isCloning"
                        placeholder="Enter website"
                ></dx-text-box>
            </div>
            <div class="py-2">
                <span>Comment</span>
                <dx-text-box
                        [(value)]="comment"
                        [showClearButton]="true"
                        placeholder="Enter comment"
                ></dx-text-box>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <dx-button
            icon="check"
            type="success"
            text="Save"
            (onClick)="saveGlobalCompanyPrefixData($event)"
    >
    </dx-button>
    <dx-button
            icon="close"
            text="Cancel"
            (onClick)="activeModal.dismiss('Cross click')"
    >
    </dx-button>
</div>
